<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">ลิสต์หน้าตกแต่ง</div>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <PreloaderSection
        v-if="loadPagesDesignerState.isLoading" />
      <div v-if="!loadPagesDesignerState.isLoading">
        <!-- render content -->
        <Section
          v-if="!loadPagesDesignerState.error">
          <!-- render content -->
          <template v-slot:section-body>
            <div v-if="!isEmpty()">
              <List>
                <template v-slot:list-header>
                  <div class="list-item-detail">
                    <div class="list-item list-item-primary list-item-title">ชื่อ</div>
                    <div class="list-item">Slug</div>
                    <div class="list-item list-item-create-at">สร้างเมื่อ</div>
                    <div class="list-item list-item-action"></div>
                  </div>
                </template>
                <template v-slot:list-body>
                  <div class="list-item-container no-underline"
                    v-for="(item, itemIndex) in pagesDesigner"
                    :key="item.id"
                    @click.stop="goToPageDetail(`/pages-designer/${item.id}`, itemIndex, $event)">
                    <div class="list-item-detail">
                      <div class="list-item list-item-primary list-item-title">
                        {{item.title}}
                      </div>
                      <div class="list-item">
                        {{item.slug}}
                      </div>
                      <div class="list-item list-item-create-at">
                        {{formatDateTime(item.createdAt)}}
                      </div>
                      <div class="list-item list-item-action">
                        <div class="action-container">
                          <router-link
                            class="btn btn-light btn-action"
                            :to="`/pages-designer/${item.id}`">
                            <i class="fas fa-pencil-alt"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </List>
            </div>
            <!-- empty list -->
            <EmptyMessage v-if="isEmpty()">
              <h3>ไม่มีข้อมูล</h3>
            </EmptyMessage>
          </template>
        </Section>
        <!-- error from api -->
        <ErrorMessageDesignerContainer
          v-if="loadPagesDesignerState.error"
          :error="loadPagesDesignerState.error" />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import Page from '@/layouts/Page.vue';
import dateFormetter from '@/utils/dateFormatter';
import Section from '@/components/Section.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

import { loadDesignerMenuList } from './api';
import ErrorMessageDesignerContainer from './ErrorMessageDesignerContainer.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Page,
    Section,
    List,
    EmptyMessage,
    ErrorMessageDesignerContainer,
    PreloaderSection,
  },
  data() {
    return {
      pagesDesigner: null,
      lastPage: null,
      programs: null,
      loadPagesDesignerState: {
        isLoading: true,
        error: null,
      },
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loadPagesDesignerState.isLoading = true;
      try {
        const response = await loadDesignerMenuList();
        this.pagesDesigner = response.data.data;
        this.loadPagesDesignerState.isLoading = false;
      } catch (error) {
        this.loadPagesDesignerState.isLoading = false;
        this.loadPagesDesignerState.error = error.response;
      }
    },
    isEmpty() {
      return _.isEmpty(this.pagesDesigner);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/form.scss';

.toggle {
  transition: all 0.3s ease-out;
  margin-right: 250px;
}

@media (max-width: 575.98px) {
  .toggle {
    margin-right: 0px;
  }
}

@media (min-width: 576px) and (max-width: 1023.98px) {
  .toggle {
    margin-right: 0px;
  }

  .list-item-container {
    .list-item-detail {
      .list-item {
        &.list-item-status {
          display: none;
        }
        &.list-item-create-at {
          display: none;
        }
        &.list-item-action {
          .action-container {
            .btn-external {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
